import { useAuth } from 'context/authentication/useAuth'
import { MobileAppLayout } from 'pages/app/mobile/layout'
import { MobileAuthLayout } from 'pages/auth/layout/mobile'

export function MobileCommonLayout() {
  const { isAuthenticated } = useAuth()
  if (isAuthenticated) return MobileAppLayout()
  return MobileAuthLayout()
}
